import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BodyClassRenderer } from '@firestitch/html';


@Component({
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class CardComponent implements OnDestroy {
  private _bodyClassRenderer = inject(BodyClassRenderer);

  constructor() {
    this._bodyClassRenderer.addClass('card');
  }

  public ngOnDestroy(): void {
    this._bodyClassRenderer.removeClass('card');
  }

}
